/*
 * Phone slideshows for the homepage category tiles, the photo bento and the brand showcase: each list
 * becomes a snapping swipe row that opens on its middle slide (so riders can swipe either way), with
 * simple dots underneath that follow the swipe and jump to a slide on tap.
 * Loaded from sections/multicolumn.liquid, sections/gallery.liquid and sections/brand-index.liquid.
 * Styles: assets/component-mobile-slides.css (layout lives in each section's own stylesheet).
 */
(() => {
  const TRACKS = [
    '[id$="__multicolumn_ybzU9y"] ul.multicolumn-list',
    '[id$="__gallery_NLQmNA"] ul.gallery-grid',
    '.brand-showcase__panels',
  ];
  const phone = window.matchMedia('(max-width: 749.98px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function centerOn(track, slide, smooth) {
    const left = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    track.scrollTo({ left, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
  }

  function build(track) {
    if (track.dataset.mobileSlides) return;
    const slides = Array.from(track.children).filter((el) => el.tagName === 'LI' || el.tagName === 'ARTICLE');
    if (slides.length < 2) return;
    track.dataset.mobileSlides = 'true';
    track.classList.add('ms-track');

    const dots = document.createElement('div');
    dots.className = 'ms-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Choose slide');
    slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ms-dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Slide ${i + 1} of ${slides.length}`);
      dot.addEventListener('click', () => centerOn(track, slide, true));
      dots.append(dot);
    });
    const anchor = track.closest('slider-component') || track;
    anchor.after(dots);

    const setActive = (index) => {
      Array.from(dots.children).forEach((dot, i) => {
        dot.setAttribute('aria-selected', String(i === index));
      });
    };

    // The slide most in view owns the active dot
    const ratios = new Map();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio));
      let best = 0;
      let bestRatio = -1;
      slides.forEach((slide, i) => {
        const ratio = ratios.get(slide) ?? 0;
        if (ratio > bestRatio) { bestRatio = ratio; best = i; }
      });
      setActive(best);
    }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 1] });
    slides.forEach((slide) => observer.observe(slide));

    // Open on the middle slide, without animating the page into place
    const middle = Math.floor((slides.length - 1) / 2);
    setActive(middle);
    requestAnimationFrame(() => requestAnimationFrame(() => centerOn(track, slides[middle], false)));

    track._msTeardown = () => {
      observer.disconnect();
      dots.remove();
      track.classList.remove('ms-track');
      delete track.dataset.mobileSlides;
      track.scrollLeft = 0;
    };
  }

  function init() {
    document.querySelectorAll(TRACKS.join(',')).forEach((track) => {
      if (phone.matches) build(track);
      else track._msTeardown?.();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  phone.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
})();
